module.exports = __webpack_public_path__ + "static/img/zzzs.fbcdada.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/img/zzzs.png
// module id = PDvK
// module chunks = 1